//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Karnofsky_info',
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Onco/Chart_Karnofsky_info.vue